import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

// @ts-ignore
import withDidMountRequest from 'app/connectors/withDidMountRequest'
// @ts-ignore
import { processReportsQuery } from 'store/entities/reviews/actions'
// @ts-ignore
import { getReviewsReportData, isReviewsReportPending } from 'store/entities/reviews/selectors'
// @ts-ignore
import { getOrganizationSettingsByDomainOrganization } from 'store/entities/organizationSettings/selectors'

import Reports from './Reports'

const mapStateToProps = createStructuredSelector({
  report: getReviewsReportData,
  organization: getOrganizationSettingsByDomainOrganization,
  isPending: isReviewsReportPending,
})

const mapDispatchToProps = {
  onRequest: processReportsQuery,
}

export default connect(mapStateToProps, mapDispatchToProps)(withDidMountRequest(Reports))
